import React, { PropTypes, Component } from 'react';
import {
  Dialog,
  TextField,
  RaisedButton,
  FlatButton,
  Toolbar,
  ToolbarGroup,
  IconButton,
  List,
  Styles,
  Paper,
  ListItem,
  ListDivider,
  Avatar
} from 'material-ui';
import ScrollableContainer from 'components/ScrollableContainer';
import * as SvgIcons from 'components/Material/SvgIcons';
import { FormattedDate } from 'react-intl';
import SearchBarToolbar from 'components/SearchBarToolbar';
import * as Colors from 'components/Material/Styles/Colors';
import ResponsiveImage from 'components/ResponsiveImage';
import DialogPortal from 'components/DialogPortal';
import Message from 'services/Message';

const { Spacing } = Styles;

const styles = {
  root: {
    position: 'relative',
    height: '100%'
  },
  floatingActionButton: {
    position: 'fixed',
    zIndex: 3
  },
  list: {
    marginTop: Spacing.desktopGutter,
    boxSizing: 'border-box'
  },
  searchBar: {
    boxSizing: 'border-box'
  },
  avatar: {
    cursor: 'pointer',
    display: 'inline-block',
    verticalAlign: 'top',
    borderRadius: 0
  },
  gridItem: {
    cursor: 'pointer',
    display: 'inline-block',
    verticalAlign: 'top',
    margin: Spacing.desktopGutterMini / 2,
    boxSizing: 'border-box',
    position: 'relative'
  },
  gridName: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    // height: 24,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '10px',
    backgroundColor: 'rgba(100, 100, 100, 0.5)',
    color: Colors.Colors.darkWhite,
    boxSizing: 'border-box',
    padding: 2
  },
  breadcrumb: {
    // backgroundColor: 'transparent',
    minWidth: 32,
    display: 'inline-block',
    margin: `10px 2px`,
    padding: `0px 4px`
  }
};

const gridSize = 140;

export default class FileList extends Component {
  static displayName = 'FileList';

  static propTypes = {
    grid: PropTypes.bool,
    hasDivider: PropTypes.bool,
    labelProperty: PropTypes.string,
    idProperty: PropTypes.string,
    items: PropTypes.array,
    onTouchTapItem: PropTypes.func,
    searchText: PropTypes.string,
    initialItemCount: PropTypes.number,
    filterChange: PropTypes.number,
    children: PropTypes.node,
    filter: PropTypes.func,
    sort: PropTypes.object,
    floatingActionButton: PropTypes.node,
    breadcrumbs: PropTypes.array
  };

  static contextTypes = {
    muiTheme: PropTypes.object,
    media: PropTypes.string,
    getIntlMessage: PropTypes.func
  };

  static defaultProps = {
    searchText: null,
    labelProperty: 'name',
    idProperty: 'id',
    initialItemCount: 25,
    sort: {
      property: 'creationDate',
      direction: 'desc'
    },
    hasDivider: true,
    items: [],
    swipeEnabled: true,
    dangerouslySetInnerHTML: false
  };

  constructor() {
    super(...arguments);
    let itemCount = 25;
    const { grid } = this.props;
    if (grid) {
      itemCount =
        Math.floor(window.innerWidth / gridSize) *
        Math.ceil(window.innerHeight / gridSize);
    } else {
      itemCount = Math.ceil(window.innerHeight / 70);
    }
    this.state = {
      maxItems: itemCount,
      deleted: {}
    };
  }

  onTouchTapItem(item) {
    if (item.type === 'dir') {
      this.props.onChangeDirectory(item.id);
    } else if (this.props.onTouchTapItem) {
      this.props.onTouchTapItem(item);
    }
  }

  onScrollToBottom() {
    let increment = 3;
    if (this.props.grid) {
      increment = Math.floor(window.innerWidth / gridSize) * 3;
    }
    this.setState({ maxItems: this.state.maxItems + increment });
  }

  getFloatingActionButtonStyle() {
    const { muiTheme, media } = this.context;
    return Object.assign({}, styles.floatingActionButton, {
      right:
        media === 'phone'
          ? Spacing.desktopGutter
          : Spacing.desktopKeylineIncrement / 2,
      bottom: media === 'phone' ? Spacing.desktopGutter : null,
      top:
        media !== 'phone'
          ? muiTheme.toolbar.height * 2 -
            muiTheme.floatingActionButton.buttonSize / 2
          : null
    });
  }

  getStyle(hasDetail) {
    return Object.assign({}, styles.root, {
      backgroundColor: this.context.muiTheme.primary1Color
    });
  }

  getDetailStyle() {
    let left = 8;
    let right = 8;
    if (this.context.media === 'desktop') {
      left = Spacing.desktopKeylineIncrement * 7;
      right = Spacing.desktopKeylineIncrement * 2;
    } else if (this.context.media === 'tablet') {
      left = Spacing.desktopKeylineIncrement * 6;
      right = Spacing.desktopKeylineIncrement * 2;
    }
    return {
      position: 'absolute',
      left: left,
      right: right,
      top: 0,
      bottom: 0,
      backgroundColor: this.context.muiTheme.rawTheme.palette.cardColor,
      overflow: 'auto',
      transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
      zIndex: 2
      // transform: 'translate3d(0,0,0)'
    };
  }

  getToolbarStyle(hasDetail) {
    const style = {
      backgroundColor: this.context.muiTheme.primary1Color,
      borderStyle: 'none none solid none',
      borderWidth: '1px',
      borderColor: '#DDD'
    };
    if (hasDetail) {
      if (this.context.media === 'desktop') {
        style.width = Spacing.desktopKeylineIncrement * 7;
      } else if (this.context.media === 'tablet') {
        style.width = Spacing.desktopKeylineIncrement * 6;
      }
    }
    return style;
  }

  getSearchHeaderStyle() {
    const { palette } = this.context.muiTheme.rawTheme;
    return Object.assign(
      {},
      {
        backgroundColor: palette.primary1Color
      }
    );
  }

  getListStyle(hasDetail = false) {
    const { media } = this.context;
    return Object.assign(
      {},
      styles.list,
      hasDetail
        ? {
            width:
              media === 'desktop'
                ? Spacing.desktopKeylineIncrement * 7
                : Spacing.desktopKeylineIncrement * 6
          }
        : null
    );
  }

  getSearchBarStyle(hasDetail = false) {
    const { media } = this.context;
    const style = {};
    if (hasDetail) {
      if (media === 'desktop') {
        style.width = Spacing.desktopKeylineIncrement * 7;
      } else if (media === 'tablet') {
        style.width = Spacing.desktopKeylineIncrement * 6;
      }
    } else if (media !== 'phone') {
      style.marginRight = Spacing.desktopKeylineIncrement * 1.5;
      style.marginLeft = Spacing.desktopKeylineIncrement * 1.5;
    }
    return Object.assign({}, styles.searchBar, style);
  }

  filter(item, searchText, labelProperty) {
    if (searchText && searchText !== '') {
      return item[labelProperty].search(searchText) > -1;
    }
    return true;
  }

  searchTextChange(searchText) {
    if (this._timer) {
      clearTimeout(this._timer);
    }
    this._timer = setTimeout(() => {
      this.setState({ searchText });
    }, 150);
  }

  componentWillReceiveProps(nextProps) {
    const { maxItems } = this.state;
    if (nextProps.grid && !this.props.grid) {
      const itemCount =
        Math.floor(window.innerWidth / gridSize) *
        Math.ceil(window.innerHeight / gridSize);
      if (itemCount > maxItems) {
        this.setState({ maxItems: itemCount });
      }
    }
  }

  toggleMode() {
    if (this.props.onToggleMode) {
      this.props.onToggleMode();
    }
  }

  changeDirectory(directoryId) {
    if (this.props.onChangeDirectory) {
      this.props.onChangeDirectory(directoryId);
    }
  }

  createDirectory() {
    this.refs.createDialog.show();
  }

  confirmCreate() {
    const name = this.refs.directoryName.getValue();
    if (name.trim().length != 0) {
      this.refs.createDialog.dismiss();
      if (this.props.onCreateDirectory) {
        this.props.onCreateDirectory(name);
      }
    } else {
      Message.info('Folder name cannot be a space');
    }
  }

  render() {
    const children = [];
    let list;
    let detail;
    let floatingActionButton;
    let regexp = '';
    let items = this.props.items;

    const { sort, labelProperty, grid } = this.props;
    const { searchText } = this.state;

    const size = grid ? gridSize : 40;

    const filter = this.props.filter || this.filter;

    if (searchText && searchText !== '') {
      regexp = new RegExp(searchText, 'i');
    }

    items = items.filter(item => {
      const created = item.created && item.created.split(' ').join('T') + 'Z';
      item.creationDate = new Date(created);
      return !item.deleted && filter(item, regexp, labelProperty);
    });
    if (sort && sort.property) {
      const sortProperty = sort.property;
      const sortDirection = sort.direction;
      items.sort((left, right) => {
        if (left.type === 'dir' && right.type !== 'dir') {
          return -1;
        } else if (left.type !== 'dir' && right.type === 'dir') {
          return 1;
        }
        if (typeof left[sortProperty] === 'string') {
          const leftProp = left[sortProperty].toUpperCase();
          const rightProp = right[sortProperty].toUpperCase();
          if (leftProp < rightProp) return sortDirection === 'asc' ? -1 : 1;
          if (leftProp > rightProp) return sortDirection === 'asc' ? 1 : -1;
          return 0;
        }
        const leftProp = left[sortProperty];
        const rightProp = right[sortProperty];
        if (leftProp < rightProp) return sortDirection === 'asc' ? -1 : 1;
        if (leftProp > rightProp) return sortDirection === 'asc' ? 1 : -1;
        return 0;
      });
    }
    items = items.splice(0, this.state.maxItems);
    for (let i = 0; i < items.length; i++) {
      const file = items[i];
      const { id, name } = file;
      const fileType = file.type;
      // const fileType = type.substring(0, type.indexOf('/'));
      let thumb;
      if (fileType === 'image') {
        // let tokens = file.url.split('.');
        // let extension = tokens.pop();
        // thumb = <Avatar src={tokens.join('.')+'-40.'+extension}/>;
        //thumb = <Avatar size={size} src={file.url} style={{borderRadius: 0}}/>;
        thumb = (
          <ResponsiveImage
            contain
            size={size}
            style={{ width: size, height: size }}
            src={file.url}
          />
        );
      } else if (fileType === 'video') {
        thumb = (
          <Avatar
            size={size}
            icon={<SvgIcons.AvMovie />}
            style={styles.avatar}
          />
        );
      } else if (fileType === 'audio') {
        thumb = (
          <Avatar
            size={size}
            icon={<SvgIcons.ImageAudiotrack />}
            style={styles.avatar}
          />
        );
      } else if (fileType === 'dir') {
        thumb = (
          <Avatar
            backgroundColor={Colors.Colors.lightBlue[400].material}
            size={size}
            icon={
              <SvgIcons.FileFolder
                color={Colors.Colors.lightBlue[400].material}
              />
            }
            style={styles.avatar}
          />
        );
      } else {
        thumb = (
          <Avatar
            size={size}
            icon={<SvgIcons.EditorInsertDriveFile />}
            style={styles.avatar}
          />
        );
      }
      const createdTime =
        (file.created && file.created.split(' ').join('T') + 'Z') || null;
      //      item.creationDate = new Date(item.created);

      // const createdTime = file.created && file.created.split(' ').join('T') || null;
      const date = (
        <span style={{ color: Colors.Colors.minBlack }}>
          {(createdTime && <FormattedDate value={new Date(createdTime)} />) ||
            ''}
        </span>
      );
      // const date = createdTime;

      if (grid) {
        const gridItem = (
          <div
            style={styles.gridItem}
            key={id}
            onTouchTap={this.onTouchTapItem.bind(this, file)}
          >
            {thumb}
            <div style={styles.gridName}>{name}</div>
          </div>
        );
        children.push(gridItem);
      } else {
        children.push(
          <ListItem
            leftAvatar={thumb}
            key={'i-' + id}
            onTouchTap={this.onTouchTapItem.bind(this, file)}
            primaryText={name}
            secondaryText={date}
          />
        );
        children.push(<ListDivider key={'d-' + id} />);
      }
    }

    const hasDetail = !!this.props.children;

    floatingActionButton =
      this.props.floatingActionButton &&
      React.cloneElement(this.props.floatingActionButton, {
        style: this.getFloatingActionButtonStyle(hasDetail)
      });

    if (hasDetail) {
      detail = (
        <Paper style={this.getDetailStyle(hasDetail)} zDepth={2}>
          {this.props.children}
        </Paper>
      );
    }

    let switchIcon;
    if (grid) {
      switchIcon = (
        <SvgIcons.ActionViewList
          color={Colors.Colors.fullWhite}
          hoverColor={Colors.Colors.grey[500].material}
        />
      );
    } else {
      switchIcon = (
        <SvgIcons.ActionViewModule
          color={Colors.Colors.fullWhite}
          hoverColor={Colors.Colors.grey[500].material}
        />
      );
    }

    // let upButton;

    const crumbs = this.props.breadcrumbs.slice().reverse();
    crumbs.unshift({
      id: 0,
      name: this.context.getIntlMessage('menu.mediaLibrary')
    });

    const breadCrumbs = crumbs.map(current => {
      return (
        <RaisedButton
          style={styles.breadcrumb}
          onTouchTap={this.changeDirectory.bind(this, current.id)}
          key={current.id}
          href={`/media-library/dir/${current.id}`}
        >
          {current.name}/
        </RaisedButton>
      );
    });

    // if (crumbs.length > 0) {
    //   let directoryId = 0;
    //   if (crumbs.length > 1) {
    //     directoryId = crumbs[1].id;
    //   }
    //   upButton = (
    //     <IconButton onTouchTap={this.changeDirectory.bind(this, directoryId)}>
    //       <SvgIcons.HardwareKeyboardArrowUp color={Colors.Colors.fullWhite} hoverColor={Colors.Colors.grey[500].material}/>
    //     </IconButton>
    //   );
    // }

    const helperBar = (
      <Toolbar>
        <ToolbarGroup style={{ margin: 0 }} float={'left'} />
        <ToolbarGroup float={'right'}>
          <RaisedButton
            primary
            style={{ margin: '10px 2px' }}
            onTouchTap={::this.createDirectory}
            label={this.context.getIntlMessage('mediaLibrary.createDir')}
          />
          <IconButton onTouchTap={::this.toggleMode}>{switchIcon}</IconButton>
        </ToolbarGroup>
      </Toolbar>
    );

    if (grid) {
      list = (
        <div style={this.getListStyle()}>
          {breadCrumbs}
          {helperBar}
          {children}
        </div>
      );
    } else {
      list = (
        <div style={this.getListStyle()}>
          {breadCrumbs}
          {helperBar}
          <List>{children}</List>
        </div>
      );
    }
    const toolbar = (
      <div style={this.getSearchHeaderStyle()}>
        <div style={this.getSearchBarStyle(hasDetail)}>
          <SearchBarToolbar fullWidth onChange={::this.searchTextChange} />
        </div>
      </div>
    );

    const createActions = [
      <FlatButton
        key="ok"
        label={this.context.getIntlMessage('Create')}
        onTouchTap={::this.confirmCreate}
      />
    ];

    return (
      <div style={this.getStyle(hasDetail)}>
        <ScrollableContainer
          containerStyle={{
            backgroundColor: this.context.muiTheme.canvasColor
          }}
          header={toolbar}
          onScrollToBottom={this.onScrollToBottom.bind(this)}
        >
          {list}
        </ScrollableContainer>
        {floatingActionButton}
        {detail}
        <DialogPortal>
          <Dialog
            ref="createDialog"
            title={this.context.getIntlMessage('mediaLibrary.createDir')}
            actions={createActions}
            actionFocus="ok"
            dismissOnClickAway
          >
            <TextField
              onEnterKeyDown={::this.confirmCreate}
              ref="directoryName"
              fullWidth
              hintText={this.context.getIntlMessage(
                'mediaLibrary.directoryName'
              )}
              floatingLabelText={this.context.getIntlMessage(
                'mediaLibrary.directoryName'
              )}
            />
          </Dialog>
        </DialogPortal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Material/FileList.js